import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useStore } from "../../../app/data/root.store";
import { VaultBulkEditRow } from "../VaultBulkEdit/VaultBulkEditRow";
import { VaultFilters } from "../VaultFilters/VaultFilters";
import { VaultInitialEmptyState } from '../VaultInitialEmptyState/VaultInitialEmptyState';
import { VaultList } from "../VaultList/VaultList";
import { VaultMainTableHeader, VaultMainTableHeaderTitle, VaultMainTableWrapper } from "./VaultMainTable.styles";
import { useVaultDropzone } from '../../hooks/useVaultDropzone';

export const VaultMainTable = observer(({ openUpload }) => {
    const { vaultStore } = useStore();
    const { getRootProps, getInputProps, isDragActive, isDropzoneDisabled } = useVaultDropzone(openUpload);
    const { ref: tableWrapperRef, ...rest } = getRootProps();

    useEffect(() => {
        if (!tableWrapperRef.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                vaultStore.setMainTableWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(tableWrapperRef.current);
        vaultStore.setMainTableWidth(tableWrapperRef.current.getBoundingClientRect().width);

        return () => {
            resizeObserver.disconnect();
        };
    }, [vaultStore, tableWrapperRef]);

    useEffect(() => {
        const fetchFiles = async () => await vaultStore.refetchFiles();
        fetchFiles();
    }, [vaultStore]);

    const isEmptyState = (!(vaultStore.isLoading) && (0 === vaultStore.meta.totalVaultsInDB));
    
    return (
        <VaultMainTableWrapper 
            ref={tableWrapperRef}
            {...rest}
            isHoverActive={isDragActive}
            isDropzoneDisabled={isDropzoneDisabled}
        >
            <input {...getInputProps()} />
            <VaultMainTableHeader isEmptyState={isEmptyState}>
                {
                    isEmptyState ?
                        <>
                            <VaultFilters />
                            <VaultInitialEmptyState />
                        </> :
                        <VaultMainTableHeaderTitle>Store, organize and analyze your financial documents</VaultMainTableHeaderTitle>
                }
                {isEmptyState ? null : <VaultFilters />}
            </VaultMainTableHeader>
            <VaultList />

            {vaultStore.isBulkEditMode && vaultStore.selectedFilesForBulkEdit.length > 0 ?
                <VaultBulkEditRow /> : null}
        </VaultMainTableWrapper>
    )
})